module.exports = __webpack_public_path__ + "static/media/pid_6.e4044dcf.svg";